export default function genererIndice() {
  return {
    libelle: '',
    indiceValeurs: [],
    actif: true,
  };
}
